import { ChangeDetectionStrategy, Component, output } from "@angular/core";
import { BiTranslatePipe } from "@globals/bi-translate";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "bi-subscription-module-reset-button",
  imports: [ButtonModule, BiTranslatePipe],
  template: `
    <p-button
      id="reset-button"
      [text]="true"
      [rounded]="true"
      tabindex="0"
      [dt]="whiteIconButton"
      type="button"
      styleClass="w-2rem h-2rem"
      [ariaLabel]="'shared.Reset' | translate"
      [title]="'shared.Reset' | translate"
      icon="fa-solid fa-redo"
      (click)="onClick.emit()"
    />
  `,
  styleUrl: "./subscription-module-reset-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export default class SubscriptionModuleResetButtonComponent {
  onClick = output();

  public whiteIconButton = {
    colorScheme: {
      light: {
        root: {
          text: {
            primary: {
              color: "{surface.0}",
              hoverBackground: "{surface.950}"
            }
          }
        }
      }
    }
  };
}
